export default {
  /**
   * 比較期間がある期間条件フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 基準
       */
      base: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * 入力エラー
         */
        errors: [],
        /**
         * ～から、～まで
         */
        weekType: 'COUNT_TO',
      },
      /**
       * 比較
       */
      compare: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * 入力エラー
         */
        errors: [],
        /**
         * ～から、～まで
         */
        weekType: 'COUNT_TO',
      },
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    return {
      base: {
        dateFrom: term.base.dateFrom,
        dateTo: term.base.dateTo,
      },
      compare: {
        dateFrom: term.compare.dateFrom,
        dateTo: term.compare.dateTo,
      },
    }
  },
  /**
   * applyToに対してtermを適用する
   * 導入前に保存された条件にはweekTypeがなく、
   * 復元時にはundefinedなのでweekTypeにはデフォルトCOUNT_TOを入れる
   */
  applyPayload(applyTo, term) {
    // 基準/比較パターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.termType = term.termType
    applyTo.base.dateFrom = term.base.dateFrom
    applyTo.base.dateTo = term.base.dateTo
    applyTo.base.weekType = term.base.weekType || 'COUNT_TO'
    applyTo.compare.dateFrom = term.compare.dateFrom
    applyTo.compare.dateTo = term.compare.dateTo
    applyTo.compare.weekType = term.compare.weekType || 'COUNT_TO'
  },
}
